const logOptimizelyVariantIds = () => {
  if (!isAnyOptimizelyEnabled()) {
    return;
  }

  document.getElementById(
    'optimizely_variant_ids'
  ).value = getVariantIds().join();
};

function isAnyOptimizelyEnabled() {
  return isOptimizelyWebEnabled() || isOptimizelyEdgeEnabled();
}

function isOptimizelyWebEnabled() {
  return window.hasOwnProperty('optimizely');
}

function isOptimizelyEdgeEnabled() {
  return window.hasOwnProperty('optimizelyEdge');
}

function getVariantIds() {
  return getActiveExperiments().map((activeExperiment) => activeExperiment.variation.id);
}

function getActiveExperiments() {
  if (isOptimizelyEdgeEnabled()) {
    return Object.values(window.optimizelyEdge.get('state').getActiveExperiments());
  }

  return Object.values(window.optimizely.get('state').getExperimentStates()).filter((state) => state.isActive);
}

export default logOptimizelyVariantIds;
